import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-timezone-component',
  templateUrl: './timezone.component.html',

})
export class TimezoneComponent {
    
}